/**
 * bubu-producto.js — ficha de producto.
 *  - Galería: flechas de 44px, puntos, teclado. Sin scrollIntoView.
 *  - CTA: cambia de texto según lo que ya hay en la caja («Añadir otro», «Añadido al carrito»).
 *  - Barra fija móvil: aparece cuando el CTA principal sale por arriba (scroll + rAF).
 */
const ficha = document.querySelector('[data-bubu-ficha]');
if (ficha) arranca(ficha);

function arranca(root) {
  // ---------- Galería ----------
  const gal = root.querySelector('[data-bubu-galeria]');
  if (gal) {
    const slides = Array.from(gal.querySelectorAll('[data-bubu-slide]'));
    // Puntos (móvil) y miniaturas (PC) comparten atributo: se marcan por su índice
    // propio, no por su posición en la lista, porque conviven las dos series.
    const puntos = Array.from(gal.querySelectorAll('[data-bubu-gal-ir]'));
    let i = 0;
    // En móvil la galería es un carril de verdad: se desliza con el dedo (scroll nativo,
    // con inercia y sin JS de por medio) y las flechas y los puntos solo lo empujan.
    // En PC sigue siendo un fundido entre fotos, que es lo que pide el diseño.
    const foto0 = gal.querySelector('[data-bubu="galeria-foto"]');
    const esCarril = () => gal.classList.contains('is-carril');
    const ir = (n, suave) => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      if (esCarril() && foto0) {
        foto0.scrollTo({ left: slides[i].offsetLeft - foto0.offsetLeft, behavior: suave === false ? 'auto' : 'smooth' });
      }
      slides.forEach((s, k) => s.classList.toggle('is-activa', k === i));
      puntos.forEach((p) => {
        const k = Number(p.dataset.bubuGalIr);
        p.classList.toggle('is-activo', k === i);
        p.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });
      pintaVideos();
      precarga();
    };
    // Las fotos que no son la primera van con loading="lazy" y en PC están ocultas
    // hasta que les toca, así que el navegador no las pedía hasta el clic en la flecha
    // y la foto aparecía a medias. Se piden por adelantado la anterior y la siguiente
    // a la que se está viendo (y la siguiente ya al abrir la ficha): el resto sigue
    // sin descargarse hasta que haga falta.
    const precarga = () => {
      if (slides.length < 2) return;
      [i - 1, i + 1].forEach((k) => {
        const im = slides[(k + slides.length) % slides.length].querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      });
    };
    // Los vídeos de la galería solo se descargan cuando les toca su turno (data-src) y
    // solo suena el que está a la vista. Sin esto, abrir una ficha con tres vídeos se
    // llevaba varios megas antes de que nadie los pidiera.
    const pintaVideos = () => {
      slides.forEach((s, k) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (k === i) {
          if (v.dataset.src && !v.src) v.src = v.dataset.src;
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    };
    // Lo que no se ve en una pantalla tampoco existe en el DOM: ni se mide ni descarga
    // sus miniaturas. En PC se quitan los puntos (ya están las miniaturas) y en móvil,
    // la tira. Las flechas, en cambio, están en las DOS: cambian de sitio, no se van.
    const tira = gal.querySelector('[data-bubu-gal-tira]');
    const ptos = gal.querySelector('[data-bubu-gal-puntos]');
    const flechas = Array.from(gal.querySelectorAll('[data-bubu="galeria-flecha"]'));
    const foto = gal.querySelector('[data-bubu="galeria-foto"]');
    const anclas = new Map();
    [tira, ptos].forEach((n) => { if (n) anclas.set(n, [n.parentNode, n.nextSibling]); });
    const mq = matchMedia('(max-width: 819.98px)');
    const pon = (n, si) => {
      if (!n) return;
      if (si) {
        if (!n.isConnected) { const [pa, sig] = anclas.get(n); pa.insertBefore(n, sig); }
      } else if (n.isConnected) n.remove();
    };
    const sincroniza = () => {
      const m = mq.matches;
      pon(tira, !m);
      pon(ptos, m);
      // Las flechas cuelgan de la galería, no de la foto: en móvil la foto pasa a ser el
      // contenedor que hace scroll y cualquier cosa en absoluto dentro de él se iría
      // con el contenido al deslizar.
      flechas.forEach((f) => {
        // Se comprueba el PADRE, no si está en el documento: al cargar ya vienen dentro
        // de la foto (así las pinta Liquid) y con `isConnected` no se movían nunca, se
        // quedaban dentro del carril y se iban con las fotos al deslizar.
        // En móvil cuelgan de la galería, porque allí la foto es el contenedor que hace
        // scroll y cualquier absoluto dentro de él se va con el contenido al deslizar.
        // En PC vuelven a su sitio de siempre, encima de la foto.
        const destino = m ? gal : foto;
        if (destino && f.parentNode !== destino) destino.appendChild(f);
      });
      gal.classList.toggle('is-carril', m && slides.length > 1);
      if (m && slides.length > 1) ir(i, false);
    };
    sincroniza();
    pintaVideos();
    mq.addEventListener('change', sincroniza);
    // Después de la carga, para no competir con la foto principal ni con el CSS.
    if (document.readyState === 'complete') setTimeout(precarga, 300);
    else window.addEventListener('load', () => setTimeout(precarga, 300), { once: true });

    /* ---------- Vídeo a pantalla completa ----------
       En el marco el vídeo va en silencio, en bucle y sin controles: es una foto que
       se mueve. El botón de la esquina lo abre a pantalla completa CON sonido y con
       los controles del navegador, y al salir se deja todo como estaba (silencio,
       sin controles, siguiendo en bucle en su sitio). En iPhone no existe la API de
       pantalla completa para elementos, pero sí webkitEnterFullscreen del <video>. */
    const salDeFull = (v) => {
      v.controls = false;
      v.muted = true;
      v.loop = true;
      if (v.closest('[data-bubu-slide]')?.classList.contains('is-activa')) v.play().catch(() => {});
    };
    gal.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bubu-video-full]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const v = btn.parentElement.querySelector('video');
      if (!v) return;
      if (v.dataset.src && !v.src) v.src = v.dataset.src;
      v.controls = true;
      v.muted = false;
      const pide = v.requestFullscreen || v.webkitRequestFullscreen || v.webkitEnterFullscreen;
      if (pide) {
        try {
          const r = pide.call(v);
          if (r && r.catch) r.catch(() => salDeFull(v));
        } catch (_) {
          salDeFull(v);
        }
      } else {
        salDeFull(v);
      }
      v.play().catch(() => {});
    });
    const alSalir = () => {
      if (document.fullscreenElement || document.webkitFullscreenElement) return;
      gal.querySelectorAll('video[data-bubu-ficha-video]').forEach(salDeFull);
    };
    document.addEventListener('fullscreenchange', alSalir);
    document.addEventListener('webkitfullscreenchange', alSalir);
    gal.querySelectorAll('video[data-bubu-ficha-video]').forEach((v) => {
      // iOS no dispara fullscreenchange: usa sus propios eventos del <video>.
      v.addEventListener('webkitendfullscreen', () => salDeFull(v));
    });

    // El punto activo lo manda el scroll, no al revés: se lee la foto que está más
    // centrada y se marca. Con rAF para no calcular en cada píxel del gesto.
    if (foto0) {
      let pendiente = false;
      foto0.addEventListener('scroll', () => {
        if (!esCarril() || pendiente) return;
        pendiente = true;
        requestAnimationFrame(() => {
          pendiente = false;
          const centro = foto0.scrollLeft + foto0.clientWidth / 2;
          let mejor = 0;
          let dist = Infinity;
          slides.forEach((s, k) => {
            const c = s.offsetLeft - foto0.offsetLeft + s.offsetWidth / 2;
            const d = Math.abs(c - centro);
            if (d < dist) { dist = d; mejor = k; }
          });
          if (mejor === i) return;
          i = mejor;
          slides.forEach((s, k) => s.classList.toggle('is-activa', k === i));
          puntos.forEach((p) => {
            const k = Number(p.dataset.bubuGalIr);
            p.classList.toggle('is-activo', k === i);
            p.setAttribute('aria-selected', k === i ? 'true' : 'false');
            if (k === i) p.setAttribute('aria-current', 'true');
            else p.removeAttribute('aria-current');
          });
          pintaVideos();
        });
      }, { passive: true });
    }

    gal.addEventListener('click', (e) => {
      if (e.target.closest('[data-bubu-gal-prev]')) ir(i - 1);
      else if (e.target.closest('[data-bubu-gal-next]')) ir(i + 1);
      else {
        const p = e.target.closest('[data-bubu-gal-ir]');
        if (p) ir(Number(p.dataset.bubuGalIr));
      }
    });
    gal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') ir(i - 1);
      if (e.key === 'ArrowRight') ir(i + 1);
    });
    // Arrastrar con el ratón en PC (en móvil ya se desliza solo: es scroll nativo).
    let x0 = null;
    gal.addEventListener('pointerdown', (e) => (x0 = e.clientX), { passive: true });
    gal.addEventListener('pointerup', (e) => {
      if (x0 === null || slides.length < 2 || esCarril()) { x0 = null; return; }
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1);
    });
  }

  // ---------- CTA según la caja ----------
  const productId = Number(root.dataset.productId);
  const ctas = Array.from(document.querySelectorAll('[data-bubu-cta], [data-bubu-cta-corto]'));
  function precioDe(btn) {
    const t = btn.querySelector('[data-bubu-cta-texto]');
    if (!t) return '';
    const m = t.textContent.split(' · ');
    return m.length > 1 ? m[m.length - 1].trim() : '';
  }
  ctas.forEach((b) => (b._bubuPrecio = precioDe(b)));
  function pintaCta(hecho, anadidos) {
    const q = window.BubuCart ? window.BubuCart.qtyProducto(productId) : 0;
    ctas.forEach((b) => {
      const t = b.querySelector('[data-bubu-cta-texto]');
      if (!t) return;
      // El CTA de un pack no lleva textos alternos (data-texto-*): su etiqueta la pone
      // Liquid («Añadir el pack · precio») y no cambia con la caja. Sin esta salida se
      // pintaba «undefined · 39,42 €» al añadir la Caja Sorpresa.
      if (!b.dataset.textoAnadir) return;
      const esEste = anadidos && anadidos.includes(Number(b.dataset.variantId));
      let txt = q > 0 ? b.dataset.textoOtro : b.dataset.textoAnadir;
      if (hecho && esEste) txt = b.dataset.textoHecho;
      t.textContent = b._bubuPrecio && !(hecho && esEste) ? `${txt} · ${b._bubuPrecio}` : txt;
    });
    if (hecho) {
      clearTimeout(pintaCta._t);
      pintaCta._t = setTimeout(() => pintaCta(false), 1400);
    }
  }
  document.addEventListener('bubu:cart', (e) => pintaCta(!!(e.detail && e.detail.anadidos), e.detail && e.detail.anadidos));

  // ---------- Barra fija móvil ----------
  const barra = document.querySelector('[data-bubu-ficha-barra]');
  const cta = root.querySelector('[data-bubu-cta]');
  if (barra && cta) {
    // Se comprueba en scroll/resize (con rAF) en vez de IntersectionObserver: un salto brusco
    // de scroll puede pasar de «debajo» a «encima» sin cruzar el viewport y el IO no avisaría.
    let visible = false;
    let pendiente = false;
    const comprueba = () => {
      pendiente = false;
      const fuera = cta.getBoundingClientRect().bottom < 0;
      const mostrar = fuera && window.innerWidth < 820;
      if (mostrar === visible) return;
      visible = mostrar;
      barra.hidden = !mostrar;
      requestAnimationFrame(() => barra.classList.toggle('is-visible', mostrar));
      document.body.classList.toggle('has-bubu-ficha-barra', mostrar);
    };
    const pide = () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(comprueba);
    };
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide);
    comprueba();
  }

}
